import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Table, TableComponentParams, TableClientDataManager } from '@ui-kit/table';
import { RepairOrderClosedResource } from '@shared/resources/repair-order';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { coinsFormat, floatFormat } from '@shared/helpers/data-converters/number-converters';
import { countItemPrice } from '@shared/helpers/sum';

interface Props {
  order: RepairOrderClosedResource;
}
interface PreviewTableRow {
  id: number,
  name: string;
  qty: string;
  price: string;
  sum: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewTable',
  props: {
    order: null
  },
  setup(__props: any) {

const props = __props as {
  order: RepairOrderClosedResource;
}

const { t } = useI18n();



const params = computed<TableComponentParams>(() => {
  return {
    searchable: false,
    columns: [
      {
        title: t('fields.name'),
        name: 'name',
        data: 'name',
      },
      {
        title: t('fields.qty'),
        name: 'qty',
        data: 'qty',
        width: 150,
      },
      {
        title: t('fields.price_local'),
        name: 'price',
        data: 'price',
        width: 150,
      },
      {
        title: t('fields.sum_local'),
        name: 'sum',
        data: 'sum',
        width: 150,
      }
    ],
  };
});

const rows = computed<PreviewTableRow[]>(() => {
  return props.order.items.map((item, index) => ({
    id: index + 1,
    name: item.name,
    qty: floatFormat(item.qty),
    price: coinsFormat(item.price),
    sum: coinsFormat(countItemPrice(item)),
  }));
});
const manager = new TableClientDataManager({
  providedData: rows,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Table), {
    params: _unref(params),
    "data-manager": _unref(manager)
  }, null, 8, ["params", "data-manager"]))
}
}

})